import React from "react";

/**
 * Success line after duplicating a record: "Created" + clickable name + optional footer (e.g. due date).
 */
export default function DuplicateSuccessMessage({ linkLabel, onOpenDetail, footer }) {
  const label = (linkLabel != null && String(linkLabel).trim() !== "") ? String(linkLabel).trim() : "New record";
  return (
    <div style={{ fontSize: "13px", color: "#212529" }}>
      <span>Created </span>
      <button
        type="button"
        className="btn-link"
        onClick={(e) => {
          e.preventDefault();
          onOpenDetail();
        }}
        style={{ padding: 0, verticalAlign: "baseline", fontWeight: 600 }}
      >
        {label}
      </button>
      <span>.</span>
      {footer != null && footer !== "" ? (
        <div style={{ marginTop: "10px", whiteSpace: "pre-wrap" }}>{footer}</div>
      ) : null}
    </div>
  );
}
